export default function DownloadCTA() {
  return (
    <section id="download" className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20waves%20in%20earthy%20terracotta%20and%20sand%20tones%2C%20minimalist%20geometric%20overlay%20patterns%2C%20clean%20modern%20aesthetic%2C%20bright%20airy%20atmosphere%2C%20subtle%20glass%20texture%20elements%2C%20contemporary%20tech%20branding&width=1800&height=800&seq=cta-bg-browser&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-900/70 via-background-900/60 to-background-900/80"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好体验极速上网了吗？
        </h2>
        <p className="text-background-50/75 text-base max-w-lg mx-auto mb-10 leading-relaxed">
          免费下载91网页浏览器，开启全新的上网体验。支持Windows、macOS、Linux多平台。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="#"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-background-50 text-foreground-900 rounded-xl text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all duration-200"
          >
            <i className="ri-windows-fill text-xl w-5 h-5 flex items-center justify-center"></i>
            Windows版下载
          </a>
          <a
            href="#"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-xl text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200"
          >
            <i className="ri-apple-fill text-xl w-5 h-5 flex items-center justify-center"></i>
            macOS版下载
          </a>
          <a
            href="#"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-xl text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200"
          >
            <i className="ri-ubuntu-fill text-xl w-5 h-5 flex items-center justify-center"></i>
            Linux版下载
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 text-background-50/50 text-sm">
          <span>v4.2.0 最新版本</span>
          <span>·</span>
          <span>2026年7月15日更新</span>
          <span>·</span>
          <span>文件大小 85MB</span>
        </div>
      </div>
    </section>
  );
}